import React from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { CheckToken } from '../../login/AccessToken'
import { useState } from 'react'
import { useEffect } from 'react'

function AdminServices() {
  const history = useHistory()
  const [authToken, setAuthToken] = useState(sessionStorage.getItem('accessToken') !== undefined && sessionStorage.getItem('accessToken') !== null ? sessionStorage.getItem('accessToken') : "")
  const [accessToken, setAccessToken] = useState('')
  const headers = {
    "Authorization": `Bearer ${authToken}`
  }
  useEffect(() => {
    if (sessionStorage.getItem('accessToken') == undefined && sessionStorage.getItem('accessToken') == null) {
      history.push('/login')
    }
  }, [])

  const Token = () => {
    const check = CheckToken()
    setAuthToken(sessionStorage.getItem('accessToken'))
    return check
  }
  const navigate = (e) => {
    history.push(`/${e.target.id}`)
  }
  return (
    <div>
      <h1 style={{ paddingLeft: '35%' }}>Admin Services</h1>
      <Container>
        <Row style={{ marginTop: "2%", marginbottom: "2%", paddingBottom: '2%' }} >
          <Col >
            <Card onClick={(e) => navigate(e)} id='hlthtek-demo' style={{ width: '90%', height: '100%', cursor: 'pointer' }}>
              <div style={{ display: "flex" }} id='hlthtek-demo'>
                <img src="/img/success-black-check-mark.svg" id='hlthtek-demo' alt="" />
                <h6 id='hlthtek-demo' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                  Home
                </h6>
              </div>
            </Card>
          </Col>
          {sessionStorage.getItem('roleType') !== undefined && sessionStorage.getItem('roleType') === "admin" ?
            <Col >
              <Card onClick={(e) => navigate(e)} id='get_existing_details' style={{ width: '90%', height: '100%', cursor: 'pointer' }}>
                <div style={{ display: "flex" }} id='get_existing_details'>
                  <img id='get_existing_details' src="/img/success-black-check-mark.svg" alt="" />
                  <h6 id='get_existing_details' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>Get Existing Details</h6>
                </div>
              </Card>
            </Col>
            :
            []
          }
          {sessionStorage.getItem('roleType') !== undefined && sessionStorage.getItem('roleType') === "admin" ?
            <Col >
              <Card onClick={(e) => navigate(e)} id='add_update_services' style={{ width: '90%', height: '100%', cursor: 'pointer' }}>
                <div style={{ display: "flex" }} id='add_update_services'>
                  <img id='add_update_services' src="/img/success-black-check-mark.svg" alt="" />
                  <h6 id='add_update_services' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>Add Update Services</h6>
                </div>
              </Card>
            </Col>
            : []
          }
          <Col >
            <Card onClick={(e) => navigate(e)} id='transaction_records' style={{ width: '90%', height: '100%', cursor: 'pointer' }}>
              <div style={{ display: "flex" }} id='transaction_records'>
                <img id='transaction_records' src="/img/success-black-check-mark.svg" alt="" />
                <h6 id='transaction_records' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>Transaction Records</h6>
              </div>
            </Card>
          </Col>
          <Col >
            <Card onClick={(e) => navigate(e)} id='patient_details' style={{ width: '90%', height: '100%', cursor: 'pointer' }}>
              <div style={{ display: "flex" }} id='patient_details'>
                <img id='patient_details' src="/img/success-black-check-mark.svg" alt="" />
                <h6 id='patient_details' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>Patient Details</h6>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AdminServices